import React, {Component} from "react"
import {Button, Divider, Header, Segment, Table} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization} from "../../utils/localization";
import {firstCharUpper} from "../../utils/common";
import {SupportEmailLink} from "../base";
import {ClickableText, CustomGrid, CustomDivider} from "../custom-common";
import {ListConditionsWithKeywordRequest} from "../../services/types";
import {listConditionsWithKeyword} from "../../services/services";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData: {ratedClass, conditionListVersionSfId}} = state;
    return {
        ...ownProps,
        lang: user.lang,
        hasChronic: !!ratedClass.contractTerms.chronicBrokerRequested,
        hasMental: !!ratedClass.contractTerms.mentalBrokerRequested,
        hasMaternity: !!ratedClass.contractTerms.maternityBrokerRequested,
        conditionListVersionSfId
    }
};

class ConditionsWithKeyword extends Component {
    viewMoreRef = React.createRef();
    INCLUDED = 0;
    NOT_INCLUDED = 1;

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            tab: this.INCLUDED,
            page: 1,
            included: [],
            notIncluded: [],
        };
    }

    componentDidMount() {
        this.fetchData().then();
    }

    fetchData = async (overWritePage) => {
        this.setState({loading: true, error: null});
        const previousIncludedIdx = this.state.included.length > 0 ? this.state.included.length-1 : 0;
        const previousNotIncludedIdx =this.state.notIncluded.length > 0 ? this.state.notIncluded.length-1 : 0;
        try {
            const {hasChronic, hasMental, hasMaternity, conditionListVersionSfId} = this.props;
            const {page} = this.state;
            let usedPage = !!overWritePage? overWritePage : page;
            const payload = new ListConditionsWithKeywordRequest({
                hasChronic,
                hasMental,
				hasMaternity,
                page: usedPage,
                conditionListVersionSfId
			});
            const result = await listConditionsWithKeyword(payload);
            if (result.status !== 200) {
                throw Error(result.statusText);
            }
            const data = result.data;
            const curIncluded = data.conditions.filter(d => d.includedCondition);
            const curNotIncluded = data.conditions.filter(d => !d.includedCondition);
            let {included, notIncluded} = this.state;
            included = included.concat(curIncluded)
            notIncluded = notIncluded.concat(curNotIncluded)
            this.setState({
                loading: false,
                included: included,
                notIncluded: notIncluded,
                page: usedPage,
                isLastPage: data.isLastPage,
                previousIncludedIdx: previousIncludedIdx,
                previousNotIncludedIdx: previousNotIncludedIdx,
            });
        } catch (e) {
            console.warn(e);
            this.setState({loading: false, error: "It was not possible to load condition information"})
        }
    };

    setIncludedButtonRef = React.createRef()
    setNotIncludedButtonRef = React.createRef()

    setIncludedTab = () => {
        this.setIncludedButtonRef.current.ref.current.blur();
        this.setState({tab: this.INCLUDED});
    }

    setNotIncludedTab = () => {
        this.setNotIncludedButtonRef.current.ref.current.blur();
        this.setState({tab: this.NOT_INCLUDED});
    }

    renderDataArr = (dataArr, isIncluded) => {
        const response = [];
        if (!!dataArr) {
            let initial = "";
            let row = [];
            dataArr.forEach((condition, idx) => {
                const curInitial = condition.keywordName[0].toUpperCase();
                if(idx === 0){
                    initial = curInitial;
                }
                if((isIncluded && idx === this.state.previousIncludedIdx) || (!isIncluded && idx === this.state.previousNotIncludedIdx)){
                    row.push(<div key={idx} ref={this.viewMoreRef}/>)
                }

                const closeRow = () => {
                    response.push(<Table.Row key={condition.includedCondition? "a"+idx:"b"+idx} verticalAlign={"top"}>
                        <Table.Cell>
                            <Header as={'h2'}>{initial}</Header>
                        </Table.Cell>
                        <Table.Cell>
                            <CustomGrid width={12}>{row}</CustomGrid>
                            <Divider hidden/>
                        </Table.Cell>
                    </Table.Row>);

                    initial = curInitial;
                    row = [];
                }

                if(initial !== curInitial){
                    closeRow();
                }

                row.push(<CustomGrid.Row key={condition.includedCondition? "c"+idx:"d"+idx} columns={2}>
                    <CustomGrid.Column width={10} style={{marginLeft: 0, paddingLeft: 0, marginRight: 0, paddingRight: 0}}>
                        <div className={"small"}><b>{condition.conditionName}</b></div>
                        <div style={{marginTop: '5px'}} className={"small neutral700Text"}>{condition.keywordName}</div>
                    </CustomGrid.Column>

                    <CustomGrid.Column width={2} style={{marginLeft: 0, paddingLeft: 0, marginRight: 0, paddingRight: 0}}>
                        <div style={{marginTop: '5px'}} className={"small neutral700Text"}>{firstCharUpper(condition.conditionGroupName)}</div>
                    </CustomGrid.Column>
                </CustomGrid.Row>);

                if(idx === dataArr.length - 1){
                    closeRow();
                }
            });
        }

        return response;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(!!this.viewMoreRef.current && this.state.page > 1){
            this.viewMoreRef.current.scrollIntoView({behavior: 'smooth'});
        }
    }

    render() {
        const {lang} = this.props;
        const localization = getLocalization(lang);
        const strings = localization.whatsCovered;
        const {included, notIncluded, loading, tab, isLastPage} = this.state;

        return (
            <CustomGrid.Column textAlign={'left'}>
                <CustomGrid.Row columns={1}>
                    <Button {...(tab === this.NOT_INCLUDED && {color: 'grey'})}
                            basic={tab === this.NOT_INCLUDED}
                            primary={tab !== this.NOT_INCLUDED}
                            style={{width: lang === 'en' ? '12em' : '14em'}}
                            onClick={this.setIncludedTab}
                            ref={this.setIncludedButtonRef}>
                        {strings.includedInPlan}
                    </Button>

                    <Button {...(tab === this.INCLUDED && {color: 'grey'})}
                            basic={tab === this.INCLUDED}
                            primary={tab !== this.INCLUDED}
                            onClick={this.setNotIncludedTab}
                            ref={this.setNotIncludedButtonRef}>
                        {strings.notIncludedInPlan}
                    </Button>
                    <CustomDivider small hidden/>
                </CustomGrid.Row>

                <CustomGrid.Row style={{marginTop: '0.5em'}}>
                    <p><span>{strings.brellaPays}</span>
                    <SupportEmailLink />.</p>
                </CustomGrid.Row>
                <Divider hidden/>

                <Divider style={{marginLeft: 0, marginRight: 0}}/>

                <CustomGrid stackable columns={1}>
                    <CustomGrid.Row columns={1} textAlign={'center'} verticalAlign={'middle'}>
                        <CustomGrid.Column textAlign="center">
                            {this.state.loading ?
                                <React.Fragment>
                                    <Divider hidden/>
                                    <Segment padded={"very"} loading={loading} vertical basic/>
                                </React.Fragment> : <React.Fragment>

                                    <Table basic={'very'}>
                                        <Table.Body>
                                            {tab === this.INCLUDED && this.renderDataArr(included, true)}
                                            {tab === this.NOT_INCLUDED && this.renderDataArr(notIncluded, false)}
                                        </Table.Body>
                                    </Table>
                                    {!isLastPage &&
                                        <ClickableText onClick={()=> { this.fetchData(this.state.page + 1).then(); }}>
                                            {strings.viewMore}
                                        </ClickableText>
                                    }
                                </React.Fragment>}
                        </CustomGrid.Column>
                    </CustomGrid.Row>
                </CustomGrid>
            </CustomGrid.Column>
        )
    }
}

export default withRouter(connect(mapStateToProps)(ConditionsWithKeyword));
